import { useFormContext } from "react-hook-form";
import { ErrorMessage } from "@/components/atoms";
import { clsx } from "@/utils";
import { TimeAndDayFormData } from "../../types";
import { AllDayField } from "./AllDayField";
import { DateEndField } from "./DateEndField";
import { DateStartField } from "./DateStartField";
import { RepeatYearlyField } from "./RepeatYearlyField";
import { SpecificDateField } from "./SpecificDateField";
import { TimeEndField } from "./TimeEndField";
import { TimeStartField } from "./TimeStartField";

export const TimeDateField = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  const {
    watch,
    formState: { errors },
  } = useFormContext<TimeAndDayFormData>();
  const specificDate = watch("specificDate");

  return (
    <div className={clsx("flex flex-col rounded-lg bg-neutral-surface-gray p-5", className)} {...props}>
      <SpecificDateField />
      <div className="flex flex-col gap-y-1">
        <div className="grid grid-cols-2 items-center">
          {specificDate && <DateStartField className="col-span-1 mr-1 mt-5" />}
          <TimeStartField className="col-span-1 mt-5" />
        </div>
        <ErrorMessage errors={errors} name="dateStart" />
        <ErrorMessage errors={errors} name="timeStart" />
      </div>
      <div className="flex flex-col gap-y-1">
        <div className="grid grid-cols-2 items-center">
          {specificDate && <DateEndField className="col-span-1 mr-1 mt-5" />}
          <TimeEndField className="col-span-1 mt-5" />
        </div>
        <ErrorMessage errors={errors} name="dateEnd" />
        <ErrorMessage errors={errors} name="timeEnd" />
      </div>
      <div className="grid grid-cols-2 items-center">
        {specificDate && <RepeatYearlyField className="col-span-1 mt-2" />}
        <AllDayField className="col-span-1 mt-2" />
      </div>
    </div>
  );
};
